import { Component, ViewEncapsulation, Input, SimpleChange, SimpleChanges, EventEmitter, HostBinding, OnInit } from '@angular/core';
import { UpaData } from '../reels/reels-models';

@Component({
  selector: 'confirm-buttons',
  template: `
    <eva-button
      [options]="{type: acceptButtonType, link_text: acceptLabel, size: size, loader_text: loaderLabel}" [showLoading]="isLoading"
      [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="moduleUniqueId" (clickEvent)="!acceptButtonDisabled && accept()"
      [upaData]="upaData" [disabled]="acceptButtonDisabled"></eva-button>

    <eva-button *ngIf="isCancelable" [options]="{type: cancelButtonType, link_text: cancelLabel, size: size}"
      [moduleId]="moduleId" [moduleIndex]="moduleIndex" [uniqueId]="moduleUniqueId" (clickEvent)="!cancelButtonDisabled && cancel()"
      [upaData]="upaData" [disabled]="cancelButtonDisabled"></eva-button>
  `,
  styleUrls: ['./confirm-buttons.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ConfirmButtonsComponent implements OnInit {
  //TODO recibir un array de botones genéricos

  @Input() acceptCallback: Function;
  @Input() cancelCallback?: Function;
  @Input() isCancelable: boolean = true;
  //TODO angular i18n
  @Input() acceptLabel: string = 'Aceptar';
  @Input() cancelLabel: string = 'Cancelar';
  @Input() loaderLabel: string = '';
  @Input() acceptButtonType: string = '-primary';
  @Input() cancelButtonType: string = '-secondary';
  @Input() size: string = '-lg';
  @Input() acceptButtonDisabled: boolean = false;
  @Input() cancelButtonDisabled: boolean = false;

  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() moduleUniqueId: string;
  @Input() upaData: UpaData;

  @Input() customStyles: { [key: string]: string };
  @Input() modelChanges: EventEmitter<SimpleChange>;

  isLoading = false;

  @HostBinding('style') get style() {
    return this.customStyles;
  }

  ngOnInit() {
    if (this.modelChanges) {
      this.modelChanges.subscribe((changes: SimpleChanges) => {

        Object.keys(changes).forEach((key: string) => {
          if (key in this) {
            this[key] = changes[key];
          }
        });
      });
    }
  }

  accept() {
    this.isLoading = true;
    this.acceptCallback();
    this.isLoading = false;
  }

  cancel() {
    this.cancelCallback?.();
  }
}
